<template>
    <div>
        <rkm-table
            :busy="busy"
            :fields="fields.table"
            :items="items"
            hide-filters
        >
            <template #filters>
                <rkm-area
                    class="mb-2"
                    type="fieldset"
                    title="ATRIBUIR PARA TODOS OS PACIENTES"
                >
                    <rkm-form ref="RkmForm">
                        <rkm-row>
                            <rkm-col cols=6>
                                <rkm-form-select
                                    :options="form.servicos"
                                    :validations="validations.servicoId"
                                    @change="handleServico()"
                                    label="Serviço"
                                    show-default-option
                                    text-field="nome"
                                    v-model="model.servicoId"
                                    value-field="id"
                                />
                            </rkm-col>

                            <rkm-col cols=6>
                                <rkm-form-select
                                    :disabled="disableUsuarios"
                                    :options="form.usuarios"
                                    :validations="validations.lotacaoId"
                                    @change="handleProfissional()"
                                    label="Profissional"
                                    show-default-option
                                    text-field="nome"
                                    v-model="model.lotacaoId"
                                    value-field="lotacaoId"
                                />
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols=6>
                                <rkm-form-input-autocomplete
                                    :disabled="disableProcedimento"
                                    :repository="repositories.procedimento"
                                    :requestQueryStringParams="autocompletesRequestParams.queryString.procedimento"
                                    :searchFields="fields.procedimento"
                                    :text-field="p => formatProcedimento(p.codigo)"
                                    :title="titleProcedimento"
                                    :validations="validations.procedimentoId"
                                    label="Procedimento padrão"
                                    v-rkm-tooltip.hover
                                    v-model="model.procedimento"
                                >
                                    <template v-slot:itemLabel="{ item }">
                                        {{ formatProcedimento(item.codigo) }} - {{ item.nome }}
                                    </template>

                                    <rkm-input-group-append slot="append">
                                        <rkm-input-group-text>
                                            <rkm-form-radio-group v-model="additionals.searchByApelido">
                                                <rkm-form-radio :value="false">Código / Nome</rkm-form-radio>
                                                <rkm-form-radio :value="true">Apelido</rkm-form-radio>
                                            </rkm-form-radio-group>
                                        </rkm-input-group-text>
                                    </rkm-input-group-append>
                                </rkm-form-input-autocomplete>
                            </rkm-col>

                            <rkm-col cols=4>
                                <rkm-form-input-autocomplete
                                    :disabled="!model.procedimento"
                                    :repository="repositories.cid"
                                    :requestQueryStringParams="autocompletesRequestParams.queryString.cid"
                                    :searchFields="fields.cid"
                                    :text-field="c => formatCid(c.codigo)"
                                    :title="titleCidPrincipal"
                                    :validations="validations.cidPrincipalId"
                                    label="CID Principal"
                                    v-rkm-tooltip.hover
                                    v-model="model.cidPrincipal"
                                >
                                    <template v-slot:itemLabel="{ item }">
                                        {{ formatCid(item.codigo) }} - {{ item.nome }}
                                    </template>
                                </rkm-form-input-autocomplete>
                            </rkm-col>

                            <rkm-col class="col-min mt-4 pt-1">
                                <rkm-form-checkbox
                                    :checked="isCboMedico ? null : false"
                                    :disabled="!isCboMedico"
                                    v-model="model.altaMedica"
                                >
                                    Alta médica
                                </rkm-form-checkbox>
                            </rkm-col>

                            <rkm-col cols="auto" class="mt-4">
                                <rkm-button
                                    @click.stop="atribuir()"
                                >
                                    Atribuir
                                </rkm-button>
                            </rkm-col>
                        </rkm-row>
                    </rkm-form>
                </rkm-area>
            </template>

            <template v-slot:cell(data)="{ item }">
                {{ item.data }} {{ item.hora }}
            </template>

            <template v-slot:cell(paciente)="row">
                <template v-if="row.item.paciente.preferenciaNomeId !== enums.preferenciaNome.NOME_SOCIAL">
                    {{ row.item.paciente.nome }}
                </template>
                <template v-else>
                    {{ row.item.paciente.nome }} <strong>({{ row.item.paciente.nomeSocial }})</strong>
                </template>
            </template>

            <template v-slot:cell(procedimentoPadrao.codigo)="row">
                <span
                    :title="row.item.procedimentoPadrao && row.item.procedimentoPadrao.nome"
                    v-rkm-tooltip.hover
                >
                    {{ row.item.procedimentoPadrao && row.item.procedimentoPadrao.codigo }}
                </span>
            </template>

            <template v-slot:cell(cid.codigo)="row">
                <span
                    :title="row.item.cid && row.item.cid.nome"
                    v-rkm-tooltip.hover
                >
                    {{ row.item.cid && row.item.cid.codigo }}
                </span>
            </template>

            <template v-slot:cell(setor)="row">
                <span
                    v-if="row.item.setor == null"
                >
                    -
                </span>
                <span v-else>
                    {{ row.item.setor }}
                </span>
            </template>

            <template v-slot:cell(actions)="row">
                <rkm-button
                    color="primary"
                    @click.stop="openModalFinalizar(row.item)"
                    authorize="update-pronto-atendimento-fechamento-faa"
                    title="Editar"
                    small
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click.stop="faaExtraviada(row.item.id)"
                    authorize="update-pronto-atendimento-fechamento-faa"
                    color="danger"
                    small
                    title="FAA extraviada"
                    :disabled="!row.item.previousDesfechoExtraviada && !!row.item.reabertoEm"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>

                <rkm-button
                    @click="$refs.ModalCancelarFaa.open(row.item)"
                    color="secondary"
                    small
                    title="Cancelar Atendimento"
                    :disabled="!row.item.setorEstaNaTriagem"
                >
                    <rkm-icon icon="ban" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :data="data"
            ref="Modal"
        />

        <ModalCancelarFaa ref="ModalCancelarFaa" @cancelado="refreshList"/>
    </div>
</template>

<script>
// Components.
import Modal from './components/finalizar/Modal'
import ModalCancelarFaa from './components/cancelamento-faa/Modal'

// Enums.
import desfecho from '@/enums/pronto-atendimento/desfecho'
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

// Mixins.
import { repository, formats, error, data, object } from '@/mixins'

// Moment.
import moment from 'moment'

// Vuex.
import { mapActions } from 'vuex'

// Utils.
import idade from '@/utils/validations/sigtap/procedimento/idade'
import sexo from '@/utils/validations/sigtap/procedimento/sexo'

export default {
    components: { Modal, ModalCancelarFaa },
    computed: {
        isCboMedico() {

            const usuario = this.getUsuarioByLotacao(this.model.lotacaoId)

            return usuario && usuario.isMedico
        },
        autocompletesRequestParams() {

            const usuario = this.getUsuarioByLotacao(this.model.lotacaoId)

            return {
                queryString: {
                    procedimento: {
                        cbo: usuario ? usuario.ocupacao.codigo : null,
                        search_by_apelido: this.additionals.searchByApelido || false,
                    },
                    cid: {
                        procedimento_id: this.model.procedimento && this.model.procedimento.hasCidPrincipal
                            ? this.model.procedimento.id
                            : null
                    }
                },
            }
        },
        disableUsuarios() {

            return this.model.servicoId == null
        },
        disableProcedimento() {

            return (this.isUsuarioSelecionadoMedico() && this.hasProcedimentoPadrao())
                || this.model.lotacaoId == null
        },
        fields() {

            return {
                table: [
                    {
                        key: 'data',
                        label: 'Data',
                        sortable: true,
                    },
                    {
                        key: 'paciente',
                        label: 'Paciente',
                        sortable: true,
                    },
                    {
                        key: 'id',
                        label: 'FAA',
                        sortable: true,
                    },
                    {
                        key: 'usuario.nome',
                        label: 'Profissional',
                        sortable: true,
                    },
                    {
                        key: 'procedimentoPadrao.codigo',
                        label: 'Procedimento padrão',
                        sortable: true,
                    },
                    {
                        key: 'cid.codigo',
                        label: 'CID',
                        sortable: true,
                    },
                    {
                        key: 'desfecho.nome',
                        label: 'Desfecho',
                        sortable: true,
                    },
                    {
                        key: 'setor',
                        label: 'Setor',
                        sortable: true,
                    },
                    {
                        key: 'actions',
                        label: 'Ações',
                        class: 'col-min'
                    },
                ],
                procedimento: [
                    this.additionals.searchByApelido
                        ? { key: 'parametrizacao_procedimento.apelido', searchable: true }
                        : { key: 'nome', searchable: true }, { key: 'codigo', searchable: true }
                ],
                cid: [
                    { key: 'codigo', searchable: true },
                    { key: 'nome', searchable: true },
                ],
            }
        },
        titleCidPrincipal() {

            return this.model.cidPrincipal ? this.model.cidPrincipal.nome : ''
        },
        titleProcedimento() {

            return this.model.procedimento ? this.model.procedimento.nome : ''
        },
        validations() {

            return {
                servicoId: { required: true },
                lotacaoId: { required: true },
                procedimentoId: { required: true },
                cidPrincipalId: { required: !!(this.model.procedimento && this.model.procedimento.hasCidPrincipal) },
            }
        },
        items() {

            return this.data.model ? this.data.model.faas : []
        }
    },
    created() {

        this.repositories = {
            procedimento: this.getConectaSusRepository('sigtap.procedimento'),
            cid: this.getConectaSusRepository('sigtap.cid'),
            fechamentoFaa: this.getConectaSusRepository('prontoAtendimento.fechamentoFaa')
        }
    },
    data: () => ({
        enums: { desfecho, preferenciaNome },
        rules: { idade, sexo },
        model: {
            servicoId: null,
            lotacaoId: null,
            procedimento: null,
            cidPrincipal: null,
            altaMedica: false,
        },
        form: {
            servicos: [],
            usuarios: [],
        },
        additionals: {
            searchByApelido: false,
        }
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        atribuir() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid || this.data.model.faas.length == 0) return

                    let appliedForAll = true

                    this.data.model.faas.map(item => {

                        if (item.reabertoEm != null
                            && item.procedimentoPadrao
                            && item.procedimentoPadrao.codigo != null
                            && item.usuario
                            && item.usuario.id != null) {

                            appliedForAll = false

                            return
                        }

                        const pacienteIdade = this.getIdade(item.data, item.dataNascimento)
                        const usuario = this.getUsuarioByLotacao(this.model.lotacaoId)
                        const isSexoValid = this.rules.sexo(item.sexoId, this.model.procedimento.sexo)
                        const isIdadeValid = this.rules.idade(
                            pacienteIdade,
                            this.model.procedimento.idadeMinima,
                            this.model.procedimento.idadeMaxima
                        )

                        if (!item.paciente.isDesconhecido
                            && (
                                !isIdadeValid || !isSexoValid
                                || !this.hasSomePlantaoUsuarioForDataAtendimentoFaa(item, usuario.plantao))
                            ) {

                            appliedForAll = false

                            return
                        }

                        item.usuario.id = usuario.id
                        item.usuario.nome = usuario.nome
                        item.usuario.lotacaoId = usuario.lotacaoId,
                        item.procedimentoPadrao = {...this.model.procedimento, loaded: false},
                        item.cid = this.model.cidPrincipal ? this.model.cidPrincipal : null,
                        item.desfecho.id = this.model.altaMedica
                            ? this.enums.desfecho.ALTA_MEDICA
                            : null
                        item.desfecho.nome = this.model.altaMedica
                            ? this.data.form.desfechos.find(d => d.id === this.enums.desfecho.ALTA_MEDICA).nome
                            : null
                    })

                    if (!appliedForAll) {

                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Atribuição parcial',
                            message: `Algumas FAAs não receberam a atribuição por questões de validação.`
                        })
                    }
                })
        },
        openModalFinalizar(item) {

            this.$refs.Modal.open(item)
        },
        faaExtraviada(faaId) {

            const extraviar = () => new Promise(resolve => {

                const params = {
                    desfecho_id: this.enums.desfecho.FAA_EXTRAVIADA
                }

                this.setLoading()

                resolve(
                    this.repositories.fechamentoFaa.update(faaId, params)
                        .then(() => {

                            this.showSaveNotification()

                            const index = this.data.model.faas.findIndex(f => f.id === faaId)
                            this.data.model.faas.splice(index, 1)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading()))
            })

            this.showDeleteConfirmation(
                'Esta ficha será finalizada somente com as informações preenchidas até o momento e não será mais exibida para edição. Deseja continuar?',
                extraviar
            )
        },
        handleServico() {

            this.model.lotacaoId = null
            this.model.procedimento = null
            this.model.cidPrincipal = null

            if (this.periodo.start && this.periodo.end) {

                this.setLoading()

                const filters = {
                    start: this.getFormatedDate(this.periodo.start, 'DD/MM/YYYY')
                }

                if (this.model.servicoId) {

                    filters.servico_id = this.model.servicoId
                }

                this.repositories.fechamentoFaa.list(filters)
                    .then(({ data }) => {

                        this.form.usuarios = data.form.usuarios

                        this.handleProfissional()
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        handleProfissional() {

            this.model.procedimento = null
            this.model.cidPrincipal = null
            this.model.altaMedica = false

            if (this.isUsuarioSelecionadoMedico() && this.hasProcedimentoPadrao()) {

                this.model.procedimento = this.clone(this.data.form.procedimentoPadrao)
            }
        },
        isUsuarioSelecionadoMedico() {

            const usuario = this.getUsuarioByLotacao(this.model.lotacaoId)

            return usuario ? usuario.isMedico : false
        },
        getUsuarioByLotacao(id) {

            if (!this.data.form) return null

            return this.data.form.usuarios.find(u => u.lotacaoId === id) || null
        },
        hasProcedimentoPadrao() {

            return this.data.form && this.data.form.procedimentoPadrao.codigo !== null
        },
        hasSomePlantaoUsuarioForDataAtendimentoFaa(faa, plantoes) {

            const dataAtendimento = moment(faa.data, 'DD/MM/YYYY')

            return plantoes.some(plantao => {

                const inicio = moment(plantao.inicio, 'DD/MM/YYYY')
                const fim = moment(plantao.fim, 'DD/MM/YYYY')

                return inicio <= dataAtendimento && fim >= dataAtendimento
            })
        },
        isIdadeValid(idade) {

            if(!this.model.procedimento) return null

            return this.model.procedimento.idade_minima < idade && this.model.procedimento.idade_maxima > idade
        },
        getIdade(dataAtendimento, dataNascimento) {

            if (!dataNascimento) return null

            const atendidoEm = moment(dataAtendimento, 'DD/MM/YYYY')

            return atendidoEm.diff(moment(dataNascimento, "DD/MM/YYYY"), 'years', false)
        },
        refreshList(faaId) {
            const index = this.data.model.faas.findIndex(f => f.id === faaId)
            this.data.model.faas.splice(index, 1)
        }
    },
    mixins: [repository, formats, error, data, object],
    props: {
        data: { type: Object, required: true },
        busy: { type: Boolean },
        periodo: { type: Object },
    },
    updated() {

        if (this.data.form) {

            this.form.servicos = this.clone(this.data.form.servicos)
            this.form.usuarios = this.clone(this.data.form.usuarios)
        }
    },
    watch: {
        'model.procedimento': function (newValue, oldValue) {

            if (newValue !== oldValue) {

                this.model.cidPrincipal = null
            }
        },
        'data._timestamp': function (newValue, oldValue) {

            if (newValue !== oldValue) {

                this.model.servicoId = null
                this.model.lotacaoId = null
                this.model.procedimento = null
                this.model.cidPrincipal = null
                this.model.altaMedica = false

                this.$refs.RkmForm.resetValidator()
            }
        }
    }
}
</script>